import applicationModel from 'modules/application/model';

const wizardConfig = {
  model: applicationModel,
  steps: [
    {
      path: 'details',
      label: 'Basic Application Details',
      fields: [
        applicationModel.fields.name,
        applicationModel.fields.description,
        applicationModel.fields.url,
        applicationModel.fields.oauth2RedirectUrls,
        applicationModel.fields.iconUrl
      ],
      buttonText: 'Create'
    }
    // {
    //   path: 'context-menus',
    //   label: 'Context Menu Extensions',
    //   fields: [
    //     applicationModel.fields['contextMenuExtensions.mentions'],
    //     applicationModel.fields['contextMenuExtensions.tdos'],
    //     applicationModel.fields['contextMenuExtensions.watchlists'],
    //     applicationModel.fields['contextMenuExtensions.collections']
    //   ],
    //   optional: true
    // }
  ]
};

export default wizardConfig;



// WEBPACK FOOTER //
// ./src/client/plugins/applications/pages/application-wizard/wizard-config.js